'use client'

import ErrorPage from '@/components/error/ErrorPage'
import { HiddenWhenEnvironment } from '@/components/hidden-when/HiddenWhenEnvironment'
import { DictionaryText, StackTrace, Text } from '@lib-components'

const MESSAGE_KEYS = {
    ERROR_PAGE_TITLE: 'STO.ERROR.ERROR_PAGE.TITLE',
    ERROR_PAGE_DESCRIPTION: 'STO.ERROR.ERROR_PAGE.DESCRIPTION',
}

export default function Error({ error }: { error: Error & { digest?: string } }) {
    return (
        <ErrorPage
            title={
                <>
                    500 - <DictionaryText textKey={MESSAGE_KEYS.ERROR_PAGE_TITLE} />
                </>
            }
        >
            <>
                <Text>
                    <DictionaryText textKey={MESSAGE_KEYS.ERROR_PAGE_DESCRIPTION} />
                </Text>
                <HiddenWhenEnvironment isProduction>
                    <StackTrace error={error} />
                </HiddenWhenEnvironment>
            </>
        </ErrorPage>
    )
}
